import { render } from "./TempératureTabletFormComponentDetails.vue?vue&type=template&id=716a60c7"
import script from "./TempératureTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./TempératureTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__